import { takeLatest } from 'redux-saga'
import { put, all } from 'redux-saga/effects'

import callAny from './helpers/call_any'
import actionTypes from 'redux/actions/actionTypes'
import userSchoolProfileActions from 'redux/actions/userSchoolProfileActions'
import formatError from './helpers/error_formatter'
import userSync from 'sync/user_sync'
import actionUserTypes from 'helpers/enums/actionUserTypes'
import notificationTypes from 'helpers/enums/notificationTypes'

function *saveProfile(action) {
	try {
		const overlayId = notificationTypes.FEATURE_USER_SCHOOL_PROFILE_OVERLAY_ID
		yield all([
			callAny(userSync.loginNotification,
				overlayId,
				null,
				actionUserTypes.ACTION_CONTINUE
			),
			callAny(userSync.saveUserAccountInformation,
				action.schoolId,
				action.role
			),
		])
		yield put(userSchoolProfileActions.saveSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(userSchoolProfileActions.saveFailed(serverError))
	}
}


export default [
	takeLatest(actionTypes.USER_SCHOOL_PROFILE_SAVE, saveProfile),
]

export {
	saveProfile,
}
